import { useApi } from '@/api'

export const useBrandColorsResource = () => {
  const api = useApi()
  const brandOf = (organizationId: string, brandId: string) => api.api.v1.organizations({ organizationId }).brands({ brandId })

  return {
    setBrandColors: (organizationId: string, brandId: string, body: Parameters<ReturnType<typeof brandOf>['colors']['put']>[0]) =>
      brandOf(organizationId, brandId).colors.put(body),
    setBrandShade: (organizationId: string, brandId: string, shadeId: string, hex: string) =>
      brandOf(organizationId, brandId).shades({ shadeId }).patch({ hex })
  }
}
